/*
  Collection card creature-type badge switcher.

  Each product card on the collection grid (sections/collection.liquid) may
  carry a <script type="application/json" data-card-variants> map of
  {"<creature-slug>": {id, src, w, h, alt}} — one entry per creature: tag the
  product has a matching, imaged variant for, built server-side only for
  products with a "Card Type" option. Badges for slugs present in that map
  render as <button data-slug="..."> instead of a plain <span>; clicking one
  swaps the card's image and both its links to that variant, without a page
  reload.

  The image URL transform below must match snippets/card-image.liquid exactly
  (same three branches: admin square "card render" region-crop, other square
  center-crop, natural-aspect passthrough) so a swapped image looks identical
  to one rendered server-side at width: 400 — the width the grid renders
  card-image at. This mirrors the same transform already used client-side in
  sections/product.liquid's variant-select image swap.
*/
(function () {
  var CARD_IMAGE_WIDTH = 400;

  /* Fixed 6-colour pastel palette, assigned to badges by index within a card. */
  var PALETTE = [
    '#ffd6dd', /* pink */
    '#ffe6c2', /* peach */
    '#fff6b8', /* yellow */
    '#d4f5d4', /* mint */
    '#cfe8ff', /* sky */
    '#e3d6ff'  /* lavender */
  ];

  function cardImageUrls(data, width) {
    var isSquare = data.w === data.h;
    var isCardRender = isSquare && typeof data.src === 'string' && data.src.indexOf('square-') > -1;
    var sep = data.src.indexOf('?') > -1 ? '&' : '?';
    var w2 = width * 2;
    var height, src, src2x;

    if (isCardRender) {
      var cropLeft = Math.round(data.w * 0.179);
      var cropTop = Math.round(data.h * 0.052);
      var cropW = Math.round(data.w * 0.641);
      var cropH = Math.round(data.h * 0.897);
      height = Math.round(width * 1.3994);
      if (w2 > cropW) w2 = cropW;
      var region = sep + 'crop=region' +
        '&crop_left=' + cropLeft +
        '&crop_top=' + cropTop +
        '&crop_width=' + cropW +
        '&crop_height=' + cropH;
      src = data.src + region + '&width=' + width;
      src2x = data.src + region + '&width=' + w2;
    } else if (isSquare) {
      height = Math.round(width * 1.3968);
      var h2 = height * 2;
      if (h2 > data.h) {
        h2 = data.h;
        w2 = Math.round(h2 * 0.7159);
      }
      src = data.src + sep + 'width=' + width + '&height=' + height + '&crop=center';
      src2x = data.src + sep + 'width=' + w2 + '&height=' + h2 + '&crop=center';
    } else {
      height = Math.round(width / (data.w / data.h));
      src = data.src + sep + 'width=' + width;
      src2x = data.src + sep + 'width=' + w2;
    }

    return {
      src: src,
      srcset: src + ' 1x, ' + src2x + ' 2x',
      height: height
    };
  }

  /* Wraps/unwraps an <img> in the .card-aspect crop container used for R2
     fallback images (see sections/collection.liquid's .card-img--r2 rule
     for the crop maths). A card's initial R2 render (if any) already has
     this wrapper in the server-rendered markup; a CDN-image card never
     does — these keep the badge-switcher correct regardless of which state
     the card started in. */
  function wrapCardAspect(img) {
    var parent = img.parentElement;
    if (parent && parent.classList.contains('card-aspect')) return;
    var wrap = document.createElement('div');
    wrap.className = 'card-aspect';
    parent.insertBefore(wrap, img);
    wrap.appendChild(img);
  }
  function unwrapCardAspect(img) {
    var parent = img.parentElement;
    if (!parent || !parent.classList.contains('card-aspect')) return;
    parent.parentElement.insertBefore(img, parent);
    parent.parentElement.removeChild(parent);
  }

  function initCard(card) {
    if (card.dataset.cardSwitchInit) return;

    var script = card.querySelector('script[data-card-variants]');
    var badges = card.querySelectorAll('.collection-page__card-badge[data-slug]');
    if (!script || !badges.length) return;

    var map;
    try {
      map = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var img = card.querySelector('.collection-page__card-image img');
    var links = card.querySelectorAll('.collection-page__card-link, .collection-page__card-title');
    var baseUrl = card.getAttribute('data-product-url');
    if (!img || !baseUrl || !links.length) return;

    card.dataset.cardSwitchInit = 'true';

    badges.forEach(function (badge, index) {
      var hue = PALETTE[index % PALETTE.length];

      badge.addEventListener('click', function () {
        var slug = badge.getAttribute('data-slug');
        var data = map[slug];
        if (!data) return;

        if (data.r2) {
          /* Admin R2 square render (no Shopify media for this variant) — no
             CDN crop params, so .card-img--r2 zooms/pans it to the card
             bbox inside the .card-aspect wrapper (see sections/collection.liquid). */
          img.src = data.src;
          img.removeAttribute('srcset');
          img.classList.add('card-img--r2');
          wrapCardAspect(img);
        } else {
          var urls = cardImageUrls(data, CARD_IMAGE_WIDTH);
          img.src = urls.src;
          img.srcset = urls.srcset;
          img.height = urls.height;
          img.classList.remove('card-img--r2');
          unwrapCardAspect(img);
        }
        if (data.alt) img.alt = data.alt;

        var newUrl = baseUrl + '?variant=' + data.id;
        links.forEach(function (a) {
          a.setAttribute('href', newUrl);
        });

        badges.forEach(function (b) {
          b.classList.remove('is-active');
        });
        badge.classList.add('is-active');

        card.style.setProperty('--card-focus', hue);
        card.classList.add('is-switched');
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.collection-page__card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Infinite scroll (sections/collection.liquid) appends fresh card markup
     to the grid after the initial load — watch for it and wire those up too. */
  var grid = document.querySelector('.collection-page__grid');
  if (grid && 'MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('collection-page__card')) {
            initCard(node);
          }
        });
      });
    });
    observer.observe(grid, { childList: true });
  }
})();
